export const sidebarConfig = {
    sidebarMinimizedWidth: 60,
    sidebarCollapsed: 260,
    sidebarTransitionSpeed: 500
};
